import { render, staticRenderFns } from "./ModalAccess.vue?vue&type=template&id=206671f4&scoped=true&"
import script from "./ModalAccess.ts?vue&type=script&lang=ts&"
export * from "./ModalAccess.ts?vue&type=script&lang=ts&"
import style0 from "./ModalAccess.scss?vue&type=style&index=0&id=206671f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206671f4",
  null
  
)

export default component.exports